module.exports = {
    customer: 'neuraxis',
    assets: { logo: 'logo.svg' }
    
};